module.exports = __webpack_public_path__ + "img/waxusdt_eth.token.f6f288f.png";